import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/30 via-background-50 to-accent-100/20"></div>

      <div className="w-full px-4 md:px-6 py-10 md:py-0 relative z-10">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line mr-1"></i>{siteInfo.tagline}
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              吃瓜视频 — 最新热点娱乐视频免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-5">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-7">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-7 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20stylized%20entertainment%20media%20hub%20visual%2C%20floating%20video%20screens%20with%20warm%20coral%20and%20gold%20accents%2C%20dynamic%20composition%2C%20clean%20minimal%20background%2C%20editorial%20design%20aesthetic%2C%20soft%20warm%20ambient%20lighting%2C%20professional%20broadcast%20style&width=1200&height=900&seq=hero-main&orientation=landscape"
                alt="吃瓜视频 — 最新热点娱乐视频在线播放平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}